import React, {MutableRefObject} from "react";
import Dialog from "@Features/dialog/components/Dialog";
import Button from "@Generic/buttons/Button";
import useGoBack from "@Routing/hooks/useGoBack";
import Translation from "@Translation/components/Translation";
import usePassengerClassesNoLongerAvailableModal
    from "@CheckOrder/features/modals/hooks/usePassengerClassesNoLongerAvailableModal";
import useGetPassengersName
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/hooks/useGetPassengersName";

interface PassengerClassesNoLongerAvailableModalProps {
    closeModal: () => void,
    dialogRef: MutableRefObject<HTMLDialogElement>
}

function NoLongerPassengerClassAvailableModal({closeModal, dialogRef}: PassengerClassesNoLongerAvailableModalProps) {
    const {goBack} = useGoBack()
    const {noLongerAvailableClasses, affectedPassengerIdsPerClass} = usePassengerClassesNoLongerAvailableModal()
    const {getPassengerName} = useGetPassengersName()

    const getAListOfPassengers = (passengerIds: number[]) => (
        passengerIds.map((passengerId) => (getPassengerName(passengerId))).join(", ")
    )

    return (
        <Dialog dialogRef={dialogRef} className="check-order__error-modal passenger-classes-no-longer-available">
            <h4 className="title">
                <Translation
                    translationKey="check_order.passenger_classes.services_no_longer_available_modal.title"
                />
            </h4>
            <p>
                <Translation
                    translationKey="check_order.passenger_classes.services_no_longer_available_modal.description"
                />
            </p>
            <p>
                <Translation
                    translationKey="check_order.passenger_classes.services_no_longer_available_modal.no_longer_available"
                />
            </p>

            {noLongerAvailableClasses.map((noLongerAvailableClass) => (
                <p>
                    {`${noLongerAvailableClass.title} (${noLongerAvailableClass.description}): `}
                    <br/>
                    {getAListOfPassengers(affectedPassengerIdsPerClass[noLongerAvailableClass.id])}
                </p>
            ))}
            <Button onClick={closeModal} className="green" additionalClasses="reload-btn">
                OK
            </Button>
            <Button onClick={goBack} className="primary-transparent">
                <Translation translationKey="check_order.back_to_search_results"/>
            </Button>
        </Dialog>
    )
}

export default NoLongerPassengerClassAvailableModal